import {FACTIONS} from '../../constants/factions';

/**
 * РЕЕСТР МИССИЙ СЮЖЕТНЫХ КАМПАНИЙ.
 *
 * Каждая миссия — конфиг, выгруженный «Редактором миссий» (кнопка «Создать
 * миссию» на странице «Кампании», доступна админам). Порядок в массиве =
 * порядок прохождения внутри кампании фракции.
 *
 * Флаг `isAdminOnly` ставится ЗДЕСЬ, а не в самом конфиге миссии: это
 * состояние выпуска, а не свойство миссии. Пока он стоит, миссию видят и
 * могут пройти только админы, а обычным игрокам кампания фракции
 * показывается прежней заглушкой «В разработке». Выпустить миссию = убрать
 * флаг в этом файле.
 *
 * Как добавить миссию — см. developer_artifacts/tasks/mission_editor.md
 */

import humansMission1 from './humans/humans_1';
import humansMission2 from './humans/humans_2';
import humansMission3 from './humans/humans_3';
import humansMission4 from './humans/humans_4';
import humansMission5 from './humans/humans_5';
import humansMission6 from './humans/humans_6';
import humansMission7 from './humans/humans_7';
import humansMission8 from './humans/humans_8';

export const CAMPAIGN_MISSIONS = {
  [FACTIONS.HUMANS]: [
    {...humansMission1, isAdminOnly: true},
    {...humansMission2, isAdminOnly: true},
    {...humansMission3, isAdminOnly: true},
    {...humansMission4, isAdminOnly: true},
    {...humansMission5, isAdminOnly: true},
    {...humansMission6, isAdminOnly: true},
    {...humansMission7, isAdminOnly: true},
    {...humansMission8, isAdminOnly: true},
  ],
};

/**
 * Миссии кампании фракции, доступные конкретному игроку.
 * @param {string} factionId
 * @param {Object} [options]
 * @param {boolean} [options.isAdmin] - админ видит и невыпущенные миссии
 */
export const getCampaignMissions = (factionId, {isAdmin = false} = {}) => (CAMPAIGN_MISSIONS[factionId] || [])
  .filter((mission) => isAdmin || !mission.isAdminOnly);

// Миссия по id — БЕЗ фильтра по правам: доступ проверяют вызывающие
// (страница кампании и серверный эндпоинт награды), а бутстрап партии должен
// поднимать уже разрешённую миссию
export const getCampaignMission = (missionId) => Object.values(CAMPAIGN_MISSIONS)
  .flat()
  .find((mission) => mission.id === missionId) || null;

// Есть ли у фракции хотя бы одна ДОСТУПНАЯ игроку миссия — по этому признаку
// кнопка кампании на странице «Кампании» перестаёт быть заглушкой
export const checkIfCampaignPlayable = (factionId, options) => getCampaignMissions(factionId, options).length > 0;
